import React from 'react';
import { IconProps } from './types';

export const DownloadIcon = (props: IconProps) => {
  const { size = 16, color = 'currentColor', style = {} } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
    >
      <path
        fill={color}
        d='M20.928 13.44c-.576 0-.96.384-.96.96v3.84c0 .288-.096.48-.288.672-.192.192-.384.288-.672.288H5.568c-.288 0-.48-.096-.672-.288-.192-.192-.288-.384-.288-.672V14.4c0-.576-.384-.96-.96-.96s-.96.384-.96.96v3.84c0 .768.288 1.536.864 2.016.48.576 1.248.864 2.016.864h13.44c.768 0 1.536-.288 2.016-.864.48-.576.864-1.248.864-2.016V14.4c0-.48-.384-.96-.96-.96z'
      />
      <path
        fill={color}
        d='M11.616 15.072c.096.096.192.192.288.192.096.096.288.096.384.096.096 0 .288 0 .384-.096.096-.096.192-.096.288-.192l4.8-4.8a.928.928 0 000-1.344.928.928 0 00-1.344 0l-3.168 3.168V2.88c0-.576-.384-.96-.96-.96s-.96.384-.96.96v9.216L8.16 8.928a.928.928 0 00-1.344 0 .928.928 0 000 1.344l4.8 4.8z'
      />
    </svg>
  );
};
